var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { APP_ROUTES, Button, useAppNavigate } from '@core';
import { CONSTRUCTOR_ROUTES } from '@features/constructor/constants';
import { DESIGNING_ROUTES } from '@features/home/constants';
import { useLocation, useSearchParams } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
export var DesigningHeader = function () {
    var navigate = useAppNavigate();
    var location = useLocation();
    var search = useSearchParams()[0];
    var isActive = function (route) { return location.pathname.endsWith(route); };
    return (_jsxs("div", __assign({ className: "flex w-full flex-col gap-[30px]" }, { children: [_jsx("p", __assign({ className: "font-sans text-lg font-semibold leading-6" }, { children: "\u041A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438" })), _jsxs("div", __assign({ className: "flex flex-row gap-[20px]" }, { children: [_jsx(Button, __assign({ className: twMerge('h-[30px] px-[16px] font-sans text-sm font-semibold shadow-none', isActive(CONSTRUCTOR_ROUTES.designing.route)
                            ? ''
                            : 'bg-white text-primary ring-[2px] ring-inset ring-primary enabled:hover:bg-white'), onClick: function () {
                            return navigate(APP_ROUTES.designing.route +
                                '/' +
                                DESIGNING_ROUTES.constructor.route +
                                '/' +
                                CONSTRUCTOR_ROUTES.designing.route, {
                                reportId: search.get('reportId'),
                                reportType: search.get('reportType'),
                            });
                        } }, { children: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438" })), _jsx(Button, __assign({ className: twMerge('h-[30px] px-[16px] font-sans text-sm font-semibold shadow-none', isActive(CONSTRUCTOR_ROUTES.myConstructions.route)
                            ? ''
                            : 'bg-white text-primary ring-[2px] ring-inset ring-primary enabled:hover:bg-white'), onClick: function () {
                            return navigate(APP_ROUTES.designing.route +
                                '/' +
                                DESIGNING_ROUTES.constructor.route +
                                '/' +
                                CONSTRUCTOR_ROUTES.myConstructions.route, {
                                reportId: search.get('reportId'),
                                reportType: search.get('reportType'),
                            });
                        } }, { children: "\u041C\u043E\u0438 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438" }))] }))] })));
};
